<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-text-field
          v-model="values.days"
          @input="submit"
          :rules="[rules.days]"
          class="mt-0 pt-0"
          single-line
          dense
          :suffix="$vuetify.lang.t('$vuetify.map.tableFilter.duration.days')"
          placeholder="0"
          style="width: 110px"
          type="number">
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="values.hours"
          @input="submit"
          :rules="[rules.hours]"
          class="mt-0 pt-0"
          single-line
          dense
          :suffix="$vuetify.lang.t('$vuetify.map.tableFilter.duration.hours')"
          placeholder="0"
          style="width: 110px"
          type="number">
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="values.minutes"
          @input="submit"
          :rules="[rules.minutes]"
          class="mt-0 pt-0"
          single-line
          dense
          :suffix="$vuetify.lang.t('$vuetify.map.tableFilter.duration.minutes')"
          placeholder="0"
          style="width: 110px"
          type="number">
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="values.seconds"
          @input="submit"
          :rules="[rules.seconds]"
          class="mt-0 pt-0"
          single-line
          dense
          :suffix="$vuetify.lang.t('$vuetify.map.tableFilter.duration.seconds')"
          placeholder="0"
          style="width: 110px"
          type="number">
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce'
import { defaultDurationFilterState } from '../../../../utils/filters'

export default {
  name: 'durationFilter',
  props: {
    type: String
  },
  data: () => ({
    values: defaultDurationFilterState(),
    rules: {
      seconds: value => (value >= 0 && value <= 60) || `0 <= seconds <= 60`,
      minutes: value => (value >= 0 && value <= 60) || `0 <= minutes <= 60`,
      hours: value => (value >= 0 && value <= 24) || `0 <= hours <= 60`,
      days: value => value >= 0 || `days >= 0`
    }
  }),
  methods: {
    submit:
      debounce(function () {
        this.$emit('value-changed', {
          type: this.type,
          values: {
            seconds: Number(this.values.seconds),
            minutes: Number(this.values.minutes),
            hours: Number(this.values.hours),
            days: Number(this.values.days)
          }
        })
      }, 250),
    clearState () {
      this.values = defaultDurationFilterState()
    }
  }
}
</script>

<style scoped>

</style>
